import { useSelector } from 'react-redux';
import { useTranslation } from 'react-i18next';
import { IAppState } from '@mafc/common';
import { Packaging, ServiceFee, TruckDelivery } from '@mafc/icon';
import { Box, Drawer } from '@mafc/trolly';

import * as S from './HowOurFeesWork.style';
import { StyledDrawerTitle } from 'common/styled/Drawer.style';

const HowOurFeesWork: React.FC<{
  isOpen: boolean;
  closeDrawer: () => void;
}> = ({ isOpen, closeDrawer }) => {
  const { t } = useTranslation();

  const {
    countryConfiguration: {
      checkoutLocalized: {
        deliveryFeeDesc: {
          deliveryFee = {},
          serviceFee = {},
          packingFee = {},
          surchargeTitle = '',
        } = {},
      } = {},
    } = {},
  } = useSelector((state: IAppState) => state && state.appConfig);

  return (
    <Drawer
      anchor={['bottom', null, 'right']}
      isOpen={isOpen}
      onClose={closeDrawer}
      title={<StyledDrawerTitle>{t('deliverySlot.howDoOurFeesWork')}</StyledDrawerTitle>}
      variant="float"
      containerStyles={{
        borderTopLeftRadius: [4, null, null, 0],
        borderTopRightRadius: [4, null, null, 0],
      }}
      isTitleBorder={false}
      contentStyles={{ pt: 1, borderRadius: '20px' }}
      width={[null, null, '480px']}
    >
      <S.HowOurFeesWork>
        <S.SurchargeText>{surchargeTitle}</S.SurchargeText>

        {deliveryFee.title && (
          <S.FeeItem>
            <S.IconWrapper>
              <TruckDelivery />
            </S.IconWrapper>
            <Box>
              <S.FeeTitle>{deliveryFee.title}:</S.FeeTitle>
              <S.FeeDescription>{deliveryFee.desc}</S.FeeDescription>
            </Box>
          </S.FeeItem>
        )}

        {serviceFee.title && (
          <S.FeeItem>
            <S.IconWrapper>
              <ServiceFee />
            </S.IconWrapper>
            <Box>
              <S.FeeTitle>{serviceFee.title}:</S.FeeTitle>
              <S.FeeDescription>{serviceFee.desc}</S.FeeDescription>
            </Box>
          </S.FeeItem>
        )}

        {packingFee.title && (
          <S.FeeItem>
            <S.IconWrapper>
              <Packaging />
            </S.IconWrapper>
            <Box>
              <S.FeeTitle>{packingFee.title}:</S.FeeTitle>
              <S.FeeDescription>{packingFee.desc}</S.FeeDescription>
            </Box>
          </S.FeeItem>
        )}
      </S.HowOurFeesWork>

      <S.GoItButton onClick={closeDrawer} variant="secondary" preventTextTransform>
        {t('deliverySlot.okGotIt')}
      </S.GoItButton>
    </Drawer>
  );
};

export default HowOurFeesWork;
